import Chip from '@mui/joy/Chip'
import type { BotStatus } from '../../api/dsGmeetApi'

type ChipColor = 'neutral' | 'primary' | 'success' | 'warning' | 'danger'

/**
 * Status → color mapping kept in one place per the ADR (so queue, detail, and
 * upcoming list stay in sync). Any new status added to the backend must be added here.
 */
function getCallStatusColor(status: BotStatus): ChipColor {
    switch (status) {
        case 'CREATED':
        case 'RECORDING':
            return 'primary'
        case 'DONE':
        case 'PENDING':
            return 'warning'
        case 'PROCESSED':
            return 'success'
        case 'UNATTRIBUTED':
            return 'neutral'
        case 'FAILED':
        case 'CANCELLED':
            return 'danger'
        default:
            return 'neutral'
    }
}

export function StatusPill({ status, size }: { status: BotStatus; size?: 'sm' | 'md' | 'lg' }) {
    return (
        <Chip color={getCallStatusColor(status)} size={size ?? 'sm'} variant="soft">
            {status}
        </Chip>
    )
}
